import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    trackingTypesBlock: {
      display: 'flex',
      width: '100%',
    },
    trackingTypeButton: {
      backgroundColor: '#F4F4F4',
      borderRadius: '6px',
      width: '360px',
      flex: 1,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 35px',
      // border: `2px solid #F4F4F4`,
      transition: 'all .3s',
      '&:not(:last-child)': {
        marginRight: '50px',
      },
      '&:hover': {
        // border: `2px solid ${accentColor}`,
        boxShadow: `0px 0px 10px 0px ${accentColor}`,
      },
    },
    trackingTypeButtonDisabled: {
      backgroundColor: '#F4F4F4',
      borderRadius: '6px',
      width: '360px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 35px',
      transition: 'all .3s',
      '&:not(:last-child)': {
        marginRight: '50px',
      },
      opacity: 0.5,
      border: '1px solid black',
    },
    trackingBlockHeader: {
      fontSize: 20,
      fontWeight: 'bold',
      textAlign: 'center',
    },
    trackingBlockContent: {
      marginTop: 24,
    },
    content: {
      fontSize: 14,
      marginTop: 12,
    },
    subheader: {
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'sans-serif',
    },
    list: { display: 'flex' },
    point: {
      width: 5,
      height: 5,
      borderRadius: 5,
      backgroundColor: accentColor,
      marginRight: 10,
      flex: '1 0 auto',
      marginTop: '9px',
    },
    footer: {
      justifyContent: 'flex-end',
      display: 'flex',
      marginTop: '30px',
      cursor: 'pointer',
      opacity: 0.8,
      '&:hover': {
        opacity: 1,
        textDecoration: 'underline',
      },
    },
    footerText: { color: accentColor },
    infoIcon: {
      fill: accentColor,
    },
    infoIconBlock: {
      marginRight: '8px',
    },
  }
}
